<template>
  <v-app>
    <RouterView />
  </v-app>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'

const auth = useAuthStore()

onMounted(async () => {
  await auth.bootstrap()
})
</script>

<style lang="scss">
// ORDER MATTERS. ml-components' settings.scss does `@use 'vuetify/settings'
// with (...overrides...)`, which only works if vuetify/settings hasn't been
// loaded yet. Vuetify's compiled `vuetify/styles` internally loads
// vuetify/settings with defaults — so it has to come AFTER the override.
@use '@medlive-tech/ml-components/dist/styles/settings';
@use 'vuetify/styles';

// Medlive brand fonts — Poppins for headers, Figtree for body. Match the type
// pairing used on www.medlive.com and solutions.medlive.com.
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&family=Figtree:wght@400;500;600;700&display=swap');

:root {
  // Brand color tokens — also exposed via CSS variables so non-Vuetify
  // components and inline styles can reach them.
  --ml-brand-purple: #7715c0;       // Early Dusk (primary)
  --ml-brand-magenta: #cb31ae;      // Horizon Line
  --ml-brand-nightfall: #2d1493;
  --ml-brand-true-blue: #007acc;    // CTAs only
  --ml-brand-starlight: #11c2f3;
  --ml-brand-body: #363d44;         // Cool Dark Gray
  --ml-brand-header-gray: #8597a8;  // Cool Gray
  --ml-brand-bg: #e7ebee;           // Winter Light
  --ml-gradient: linear-gradient(135deg, #7715c0 0%, #cb31ae 100%);
}

html, body, #app { height: 100%; }

body {
  font-family: 'Figtree', 'Arial', sans-serif;
  color: var(--ml-brand-body);
  background: #fafbfc;
}

h1, h2, h3, h4, h5, h6,
.text-h1, .text-h2, .text-h3, .text-h4, .text-h5, .text-h6 {
  font-family: 'Poppins', sans-serif !important;
  letter-spacing: -0.01em;
}

// Subtle page background so cards have something to sit on top of, matching
// solutions.medlive.com's content-on-tinted-canvas style.
.v-main {
  background: #f7f8fa;
}
</style>
